import { loadGtmEvents } from '@src/scripts/shared/config';

loadGtmEvents();
